'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('external.insert-email', {
    views: {
      'externalContent': {
        component: 'insertEmail',
      }
    }
  })
}



// WEBPACK FOOTER //
// ./client/app/features/insert-email/insert-email.routes.js